import { Navigate, useRoutes } from 'react-router-dom';
import DashboardLayout from './layouts/dashboard';
import SimpleLayout from './layouts/simple';
import GamePage from './pages/GamePage';
import LoginPage from './pages/LoginPage';
import Page404 from './pages/Page404';
import DashboardAppPage from './pages/DashboardAppPage';
import PickemEditPage from './pages/PickemEditPage';
import PickemQuestionPage from './pages/PickemQuestionPage';
import ImageLibraryPage from './pages/ImageLibraryPage';
import BannersPage from './pages/BannersPage';
import LeaderboardsPage from './pages/LeaderboardsPage';
import LeaderboardPage from './pages/LeaderboardPage';
import UserSelectionsPage from './pages/UserSelectionsPage';
import LeaguesPage from './pages/LeaguesPage';
import LeagueTournamentsPage from './pages/LeagueTournamentsPage';
import FriendsLeaguePage from './pages/FriendsLeaguePage';
import PagesList from './pages/PagesList';
import PageEditPage from './pages/PageEditPage';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    {
      path: '/dashboard',
      element: <DashboardLayout />,
      children: [
        { element: <Navigate to='/dashboard/pickems' />, index: true },
        { path: 'pickems', element: <GamePage /> },
        { path: 'pages', element: <PagesList /> },
        { path: 'pages/edit', element: <PageEditPage /> },
        { path: 'image-library', element: <ImageLibraryPage /> },
        { path: 'banners', element: <BannersPage /> },
        { path: 'leaderboards', element: <LeaderboardsPage /> },
        { path: 'leaderboards/view', element: <LeaderboardPage /> },
        { path: 'user-selections', element: <UserSelectionsPage /> },
        { path: 'leagues', element: <LeaguesPage /> },
        { path: 'friends-leagues', element: <FriendsLeaguePage /> },
        { path: 'league-tournaments', element: <LeagueTournamentsPage /> },
        { path: 'pickem/edit', element: <PickemEditPage /> },
        { path: 'pickem/question', element: <PickemQuestionPage /> },
        { path: 'app', element: <DashboardAppPage /> },
      ],
    },
    {
      path: 'login',
      element: <LoginPage />,
    },
    {
      element: <SimpleLayout />,
      children: [
        { element: <Navigate to='/dashboard/pickems' />, index: true },
        { path: '404', element: <Page404 /> },
        { path: '*', element: <Navigate to='/404' /> },
      ],
    },
    {
      path: '*',
      element: <Navigate to='/404' replace />,
    },
  ]);
}
